<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Salary Register</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <!-- <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month" :items="sal_month_list" item-text="name" item-value="id" label="Salary Month" outlined />
                    </v-col> -->
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-btn class="mt-6 button" @click="fetchSalaryRegister()" :loading="loader">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="emp_salary_reg_detail!=''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Salary Register Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table fixed-header dense class="elevation-1" height="500px"
                        v-if="emp_salary_reg_detail!=''">
                        <thead>
                            <tr class="toolbar">
                                <td align="center">Edit</td>
                                <td align="center">Sr. No.</td>
                                <td align="center">Employee</td>
                                <td align="center">No. Of Working Days</td>
                                <td align="center">Salary Month</td>
                                <td align="center" v-for="(header,index) in comp_header" :key="index">{{header}}</td>
                                <td align="center">Gross Salary</td>
                                <td align="center">Gross Deduction</td>
                                <td align="center">Net Salary</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s,index) in emp_salary_reg_detail" :key="index">
                                <td align="">
                                    <v-avatar v-if="s.edit_flag == 'YES'" style="" size="25" class="edit-avatar"
                                        @click="editItem(s.sal_reg_id)">
                                        <v-icon x-small class="edit-v-icon mr-2">edit</v-icon>
                                    </v-avatar>
                                    <v-avatar v-if="s.edit_flag == 'NO'" style="" size="25" class="edit-avatar">
                                        <v-tooltip top color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon x-small v-bind="attrs" v-on="on"
                                                    class="edit-v-icon mr-2">edit</v-icon>
                                            </template>
                                            <span>
                                                {{s.fmsg}}
                                            </span>
                                        </v-tooltip>
                                    </v-avatar>
                                </td>
                                <td align="">{{index+1}}</td>
                                <td align="">{{s.emp_name}}</td>
                                <td>
                                    <center>{{s.emp_working_days}}</center>
                                </td>
                                <td>
                                    <center>{{s.sal_month}}</center>
                                </td>
                                <!-- <td v-for="(comp,index1) in s.comp_value" :key="index1">
                                  <center> 
                                     {{s.comp_value[index1]}}
                                  </center> 
                                </td> -->
                                <td v-for="comp in s.comp_value" :key="comp.emp_sd_id">
                                    <center>
                                        {{comp.s_value}}
                                        <br>
                                        <v-row dense justify="center" v-if="comp.is_rule_applicable == true">
                                            <span v-if="comp.is_rule_applicable == true && comp.rule_value">
                                                <v-tooltip top color="black">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon size="20" v-bind="attrs" v-on="on"
                                                            color="black">mdi-information</v-icon>
                                                    </template>
                                                    <span>
                                                        {{comp.rule_value}}
                                                    </span>
                                                </v-tooltip>
                                                <span v-if="s.edit_flag == 'YES'">
                                                    <v-tooltip top color="black">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon size="20" v-bind="attrs" v-on="on" color="red"
                                                                @click="removeRule(comp.emp_sd_id)">mdi-filter-remove</v-icon>
                                                        </template>
                                                        <span>
                                                            Remove Applied Rule
                                                        </span>
                                                    </v-tooltip>
                                                </span>
                                            </span>
                                            <span v-if="comp.is_rule_applicable == true">
                                                <v-avatar v-if="s.edit_flag == 'YES'" style="" size="20"
                                                    class="edit-avatar" @click="addRule(comp.s_id,comp.emp_sd_id)">
                                                    <v-icon x-small class="edit-v-icon mr-2">edit</v-icon>
                                                </v-avatar>
                                            </span>
                                        </v-row>
                                    </center>
                                </td>
                                <td>
                                    <center>{{s.gross_salary}}</center>
                                </td>
                                <td>
                                    <center>{{s.gross_deductions}}</center>
                                </td>
                                <td>
                                    <center>{{s.net_salary}}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-card>
        </v-container>
        <v-dialog v-model="dialog_edit" fullscreen>
            <v-card>
                <v-col cols="12" sm="12" md="12" v-if="dialog_edit">
                    <edit-employee-salary-register :emp_sal_reg_id=emp_sal_reg_id :edit_flag=edit_flag
                        @changedialog="chnaged($event)"></edit-employee-salary-register>
                </v-col>
                <v-row justify="center" dense>
                    <v-btn class="button mt-3" @click="dialog_edit=false;emp_sal_reg_id=null">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_edit_rule" persistent max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Add Rule
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <center>
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete dense rounded outlined v-model="comp_rule_edit" :items="component_rule_edit"
                            color="#0F2027" item-text="name" return-object label="Rule" single-line></v-autocomplete>
                    </v-col>
                </center>
                <v-row justify="center">
                    <v-btn rounded class="button" @click="addrule_edit(comp_rule_edit);">Save</v-btn>
                    <v-btn rounded class="button" @click="dialog_edit_rule = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import EditEmployeeSalaryRegister from "../Employee/EditEmployeeSalaryRegister";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
       components:{
            'edit-employee-salary-register': EditEmployeeSalaryRegister,
            Breadcrumbs
        },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            employee_list: [],
            emp_salary_reg_detail: [],
            // extraBreadcrumbItems: [
               

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            comp_header:[],
            sal_month: "",
            employee: "",
            gross_salary:null,
            gross_deductions:null,
            net_salary:null,
            emp_sal_reg_id:null,
            dialog_edit_rule:false,
            dialog_edit:false,
            edit_flag:null,
            comp_rule_edit:null,
            component_rule_edit:[],
            headers: [
                { text: "Title", value: "title" },
                { text: "Description", value: "description" },
            ],
        }),
        methods: {
          
           editItem(emp_sal_reg_id){
              //  alert(emp_sal_reg_id)
                this.emp_sal_reg_id = emp_sal_reg_id
                this.edit_flag = 'yes'
                this.dialog_edit = true
            },
            chnaged(dialog){
                this.dialog_edit = dialog
                this.fetchSalaryRegister()
            },
            fetchSalaryRegister() {
                const data = {
                    // sal_month: this.sal_month,
                    employee: this.employee,
                };

                axios
                    .post("/Payroll/getEmpSalaryRegister", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.emp_salary_reg_detail = res.data.emp_salary_reg_detail;
                            this.comp_header = res.data.comp_header;
                            this.gross_salary = res.data.gross_salary
                            this.gross_deductions = res.data.gross_deductions
                            this.net_salary = res.data.net_salary
                        }
                        else if (res.data.flag == "No") {
                           this.showSnackbar("#b71c1c", res.data.snackbar);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
            onLoad() {
                axios
                    .post("/Payroll/getInitialData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                            this.employee_list = res.data.inst_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
             removeRule(emp_sd_id){
                const data = {
                   emp_sd_id:emp_sd_id,
                   comp_rule_edit:null
                }
                 axios
                    .post("/Payroll/removeSalaryRuleRegister", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Salary Rule Deleted Successfully...");
                            this.fetchSalaryRegister()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.dialog_edit_rule = false;
                    });
            },
             addRule(sid,emp_sd_id) {
                this.emp_sd_id = emp_sd_id
                const data = {
                    sid: sid,
                };
                axios
                    .post("/Payroll/addComponentRule", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.component_rule_edit = res.data.component_rule;
                            this.dialog_edit_rule = true;
                        } else {
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
            addrule_edit(comp_rule_edit){
                const data = {
                   emp_sd_id: this.emp_sd_id,
                   comp_rule_edit:comp_rule_edit
                }
                 axios
                    .post("/Payroll/UpdateSalaryRuleRegister", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dialog_edit_rule = false;
                            this.showSnackbar("#4caf50", "Salary Rule Updated Successfully...");
                            this.fetchSalaryRegister()
                        } else {
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.dialog_edit_rule = false;
                    });
                
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
 thead{
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
